import MainComponent from "components/Main";

import './index.less';
import './themes/default.less';

/**
 * Created by viclight on 04.03.2024.
 */
export default class PermissionsData extends MainComponent {


    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            absol: true,
        };
    }


    render() {

        const { name } = this.props;

        return (
            <div className="tabsPage pos rel flex1 flex minH0">
                <div className={`pageContent flex flex1 scrolling ${ name }`}>
                    <div className="wrapGeneral flex flex1 gap16">
                        This section is under construction
                    </div >
                </div>
            </div>
        );

    }

}
